module.exports = __webpack_public_path__ + "img/22.49473353.svg";